// Reducer

import { REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { View } from '../../domain/View';
import { ACTION_TYPES } from './actions';
import { RulesState, initialState } from './state';

export default (state: RulesState = initialState, action): RulesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_APP_DATA_CONF):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_APP_DATA_CONF): {
      const data = action.payload.data;
      return {
        ...state,
        ...state.dataConfList.set(data.key, data.value),
        isReady: true,
      };
    }

    case REQUEST(ACTION_TYPES.GET_DATA_VIEW):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_DATA_VIEW): {
      const data = action.payload.data;
      return {
        ...state,
        ...state.dataViewList.set(View[data?.value?.key], data.value),
      };
    }

    default:
      return state;
  }
};
